import { render, staticRenderFns } from "./private-app-detail.vue?vue&type=template&id=63734378&"
import script from "./private-app-detail.vue?vue&type=script&lang=js&"
export * from "./private-app-detail.vue?vue&type=script&lang=js&"
import style0 from "./private-app-detail.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports